import { render, staticRenderFns } from "./ActivityDetailPanel.vue?vue&type=template&id=97880300&scoped=true&"
import script from "./ActivityDetailPanel.vue?vue&type=script&lang=js&"
export * from "./ActivityDetailPanel.vue?vue&type=script&lang=js&"
import style0 from "./ActivityDetailPanel.vue?vue&type=style&index=0&id=97880300&prod&lang=scss&scoped=true&"
import style1 from "./ActivityDetailPanel.vue?vue&type=style&index=1&id=97880300&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97880300",
  null
  
)

export default component.exports